import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import Modal from '../components/common/Modal';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const initialModalState = {
    isOpen: false,
    title: '',
    message: '',
    primaryActionLabel: '',
    primaryActionCallback: null,
    secondaryActionLabel: '',
    secondaryActionCallback: null,
  };

  const [modalState, setModalState] = useState(initialModalState);

  const openModal = (newModalState) => {
    setModalState({ isOpen: true, ...newModalState });
  };

  const closeModal = () => {
    setModalState(initialModalState);
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      {modalState.isOpen && (
        <Modal modalState={modalState} closeModal={closeModal} />
      )}
    </ModalContext.Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export const useModal = () => useContext(ModalContext);
